import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { fetchCrearDepartamento } from '../../../peticiones_API/PeticionesGestionPersonasDepartamentos';
import ErrorForm from '../eventos/avisos/Alerta';
import { handleChangeErrors, handleSubmitErrorsDepartamentos, todosDatosCorrectos } from '../../validacion/ValidationFormDepartamento';
import { DatosCorrectosDepartamento, ServerNoCreoDepartamento, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { ToastContainer, toast } from "react-toastify";
import useFormPersistence from '../../../hooks/useFormPersistence';


const FormCrearDepartamento = ({ departamentos, negocios }) => {

const initialFormState = {
        nombre: '',
        Negocios: null,
        tipo: 'interno',
        mandos_intermedios: []
    };

const [formData, setFormData, clearFormDraft] = useFormPersistence(
    'crear_departamento',
    initialFormState
);

    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
    };

    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: null,
    });

    let [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);
    const [mostrarMandoIntermedio, setMostrarMandoIntermedio] = useState(false);

    const [errorEnviarForm, setErrorEnviarForm] = useState({
        departamentoDuplicado: null,
        refDuplicado: null

    });

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setFormCompletado(null);
        setErrorEnviarForm({ departamentoDuplicado: null, refDuplicado: null });
        setEstadosActualizados(false);
        
        handleSubmitErrorsDepartamentos(formData, estadoCampoReque, setEstadoCampoReque, camposRequeridos, setEstadosActualizados);
    };

    const handleChangeNegocios = (event) => {
        const {
            target: { value },
        } = event;
        setFormData(prevData => ({
            ...prevData,
            Negocios: value.map(id => ({ Id: id }))
        }));
    };

    useEffect (() => {

        if (estadosActualizados) {

            let validacionTodosDatos = todosDatosCorrectos(formData, estadoCampoReque);
            let todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    try {

                        const response = await fetchCrearDepartamento(formData);
                        clearFormDraft();
                        console.log("Departamento creado: ", response);

                    } catch (error) {

                        console.error(error);

                        if (error?.response?.data?.error === 'REGISTRO_DUPLICADO') {
                            setErrorEnviarForm(prevFormData => ({ ...prevFormData, departamentoDuplicado: true }));
                        }
                        setFormCompletado(false);

                    }
                } else {
                    toast.error("Faltan campos por rellenar")
                }
                setEstadosActualizados(false);
            })();
        }
    }, [estadosActualizados, formData, estadoCampoReque])

    const handleChange = (event) => {
        const { name, value, type, files } = event.target

        let newValue

        if(type === 'file') {
            newValue = files[0]
        }
        else {
            newValue = value
        }

        setFormData(prevFormData => ({ ...prevFormData, [name]: newValue }));
        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }
    }

    return ( 
        <>
            <Form>
                <CabeceraForm>
                    <Titulo texto="CREAR UN DEPARTAMENTO" />
                </CabeceraForm>

                <Container>
                    <ToastContainer/>
                    <Col>
                        <Row md="3">
                            <Form.Group className="mb-12">
                                <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                                <Form.Control type='name' name='nombre' className="py-3" value={formData.nombre || ''} onChange={handleChange} />
                                <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>Negocios</TituloCategoria>
                                {negocios.length > 0 && (
                                <Select
                                    multiple
                                    style={{ width: '100%', maxWidth: '500px', minHeight: '40px' }}
                                    value={formData.Negocios ? formData.Negocios.map(negocio => negocio.Id) : []}
                                    onChange={handleChangeNegocios}
                                    renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map((id) => {
                                                const negocio = negocios.find(c => c.Id === id);
                                                return <Chip key={id} label={negocio ? negocio.nombre : ''} />;
                                            })}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {negocios.map((negocio) => (
                                        <MenuItem key={negocio.Id} value={negocio.Id}>
                                            {negocio.nombre}
                                        </MenuItem>
                                    ))}
                                </Select>
                                )}
                                <ErrorForm mensaje={camposRequeridos.negocios} estadoAlerta={estadoCampoReque.negocios} />
                            </Form.Group>

                            <Form.Group className="mb-12">
                                <TituloCategoria>Tipo de Departamento</TituloCategoria>
                                <div style={{ transform: 'scale(1.4)', marginLeft: '70px', marginTop: '15px' }}>
                                    <Form.Check
                                        type="checkbox"
                                        id="tipo-organigrama"
                                        label="Organigrama"
                                        checked={formData.tipo === 'organigrama'}
                                        onChange={e => {
                                            setFormCompletado(null);
                                            setErrorEnviarForm({ departamentoDuplicado: null, refDuplicado: null });
                                            setFormData(prev => ({
                                                ...prev,
                                                tipo: e.target.checked ? 'organigrama' : 'interno'
                                            }));
                                        }}
                                    />
                                </div>
                            </Form.Group>

                            {formData.tipo === 'organigrama' && (
                            <Form.Group className="mb-12">
                                <TituloCategoria>Mando Intermedio</TituloCategoria>
                                <div style={{ transform: 'scale(1.4)', marginLeft: '70px', marginTop: '15px', marginBottom: '15px' }}>
                                    <Form.Check
                                        type="checkbox"
                                        id="mando-intermedio"
                                        label="Es mando intermedio"
                                        checked={mostrarMandoIntermedio}
                                        onChange={e => {
                                            setMostrarMandoIntermedio(e.target.checked);
                                            if (!e.target.checked) {
                                                setFormData(prev => ({ ...prev, mandos_intermedios: [] }));
                                            }
                                        }}
                                    />
                                </div>
                                {mostrarMandoIntermedio && (
                                    <>
                                        <TituloCategoria>Departamentos padre (máx. 2)</TituloCategoria>
                                        <Select
                                            multiple
                                            style={{ width: '100%', maxWidth: '500px', minHeight: '40px' }}
                                            value={formData.mandos_intermedios || []}
                                            onChange={(event) => {
                                                const value = event.target.value;
                                                if (value.length <= 2) {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        mandos_intermedios: value
                                                    }));
                                                }
                                            }}
                                            renderValue={(selected) => (
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                    {selected.map((id) => {
                                                        const dep = departamentos.find(d => d.Id === id);
                                                        return <Chip key={id} label={dep ? dep.nombre : ''} />;
                                                    })}
                                                </Box>
                                            )}
                                            MenuProps={MenuProps}
                                        >
                                            {departamentos
                                                .filter(dep => dep.tipo === 'organigrama' && dep.Id !== formData.Id)
                                                .filter(dep => {
                                                    if (!formData.Negocios || formData.Negocios.length === 0) return true;
                                                    const negociosSeleccionados = formData.Negocios.map(e => e.Id);
                                                    return dep.Negocios && dep.Negocios.some(e => negociosSeleccionados.includes(e.Id));
                                                })
                                                .map((dep) => (
                                                    <MenuItem key={dep.Id} value={dep.Id}>
                                                        {dep.nombre}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </>
                                )}
                            </Form.Group>
                            )}
                        </Row>
                        <Row className="mt-4">
                            <ContenedorBotones>
                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    type="submit"
                                    onClick={handleSubmit}
                                    form="true"
                                >
                                    Crear Departamento
                                </Boton>
                                <Boton
                                    grande="true"
                                    to="/gestionpersonas/departamentos"
                                >
                                    Cancelar
                                </Boton>
                            </ContenedorBotones>
                        </Row>
                    </Col>
                </Container>
            </Form>
            <DatosCorrectosDepartamento envioActivado={formCompletado} />
            <DatosIncorrectos envioActivado={formCompletado} duplicado={errorEnviarForm.departamentoDuplicado} />
            <ServerNoCreoDepartamento envioActivado={errorEnviarForm.departamentoDuplicado} />
        </>
     );
}

const CabeceraForm = styled.div`
    margin: 2% 0% 2% 35%;
`

const ContenedorBotones = styled.div`
    margin-top: 30%;
`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }
`
 
export default FormCrearDepartamento;